export const checkIsPlaylistArticle = (playlists, articleId) => {
  let isPlaylistArticle = false;
  for (const playlist of playlists) {
    const index = playlist.playListArticleIds.indexOf(articleId);
    if (index !== -1) {
      isPlaylistArticle = true;
      break;
    }
  }
  return isPlaylistArticle;
};
